import React from 'react';
import { View, Text } from 'react-native';
import { VictoryPie } from 'victory';

type Props = { active: number; inactive: number; width?: number; height?: number; title?: string };
export default function ActiveInactivePieChart({ active = 0, inactive = 0, width = 350, height = 220, title = 'Charger Activity' }: Props) {
  const a = Number(active) || 0, i = Number(inactive) || 0, total = a + i;
  const data = total === 0 ? [{ x: 'No Data', y: 1 }] : [
    { x: `Active (${a})`, y: a },
    { x: `Inactive (${i})`, y: i },
  ];
  return (
    <View style={{ width: '100%' }}>
      <View style={{ backgroundColor: '#292D33', borderRadius: 16, padding: 12 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8, paddingRight: 8 }}>
          <Text style={{ color: 'white', fontWeight: '700', fontSize: 16 }}>{title}</Text>
          <Text style={{ color: 'white', fontWeight: '600', fontSize: 11 }}>{`Total Chargers: ${total}`}</Text>
        </View>
        <View style={{ alignItems: 'center' }}>
          <VictoryPie data={data} colorScale={['#39BEB7', '#8D8E90']} width={width} height={height} style={{ labels: { fill: '#FFFFFF', fontSize: 10 } }} innerRadius={Math.max(40, Math.floor((height * 0.2)))} padAngle={2} />
        </View>
      </View>
    </View>
  );
}


